import ProductProperties, { FormFieldName } from "../../interfaces/ProductProperties/ProductProperties";
import GlobalStatesProps from "./GlobalStates.props";

export class GlobalStates {
    private props: GlobalStatesProps;

    constructor(props: GlobalStatesProps) {
        this.props = props;
    }

    setSelectedFrameworkContract(selected: string, optionName: string) {
        this.props.selectedFrameworkContract = selected;
        this.props.selectedOptionName = optionName;
    }

    getSelectedFrameworkContract() {
        return {value: this.props.selectedFrameworkContract, name: this.props.selectedOptionName};
    }

    setIsDiscountProductOfFrameworkContracts(isDiscountProduct: boolean) {
        this.props.isDiscountSelected = isDiscountProduct;
    }

    getIsDiscountProductOfFrameworkContracts() {
        return this.props.isDiscountSelected;
    }

    isDiscountable(productProperties: ProductProperties) {
        const formFieldFrameworkContracs = productProperties?.configOptions?.find(option => option.name === FormFieldName.FRAMEWORKCONTRACT);

        if (formFieldFrameworkContracs) {
            return true;
        } 
        return false;
    }
    
    getDiscountStatusFromProductProperties(productProperties: ProductProperties) {
        const formFieldFrameworkContracs = productProperties?.configOptions?.find(option => option.name === FormFieldName.FRAMEWORKCONTRACT);
        
        if (!formFieldFrameworkContracs) return false;

        if (formFieldFrameworkContracs.value !== 'nein' && formFieldFrameworkContracs.value !== 'andererVerband') {
            return true;
        } else {
            return false;
        }
    }

    setCampaignIdToGlobalStates(campaignId: string) {
        this.props.campaignId = campaignId;
    }

    getCampaignIdFromGlobalStates() {
        return this.props.campaignId;
    }

    setPageTypeToGlobalStates(pageType: string) {
        this.props.pageType = pageType;
    }

    getPageTypeFromGlobalStates() {
        return this.props.pageType;
    }
}

const globalStates = new GlobalStates({})
export default globalStates;